import { useCallback } from 'react';
import { useAxios } from './context.mjs';

function useFetcherFromRemote({
  remote,
  instanceType = "json"
}) {
  const { instances } = useAxios();
  const instance = instances[instanceType];
  return useCallback(
    (params, options) => {
      const [fetcher] = remote(instance);
      return fetcher(params, options);
    },
    [instance, remote]
  );
}

export { useFetcherFromRemote as default };
//# sourceMappingURL=useFetcherFromRemote.mjs.map
